// BugList.js


import Skeleton from '@mui/material/Skeleton';
import BugCard from './BugCard';
import { Link } from 'react-router-dom';
import axios from 'axios';
import SecurityHeaders from '../../context/SecurityHeaders';
import { useContext , useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useActionsContext } from '../../context/ActionsContext';
import { AuthContext } from '../../context/AuthContext';


const BugList = () => {
  const dispatch = useDispatch()
  const [programs, setPrograms] = useState(null);
  const {user} = useContext(AuthContext);

            const { rowsPerPage } = useActionsContext();
  const fetchPrograms = async () => {
    try {
      dispatch({type:'LOADING'})
      const data = new FormData();
      data.append('session', user.SessionId);
      data.append('limit', rowsPerPage);
      const res = await axios.post("https://skillsuprise.com/fetch-bounties.php", data,SecurityHeaders);
      if (res.data.status === 'success') {
        setPrograms(res.data.bounties);
        dispatch({type:'DONE_LOADING'})
      } else {  

        dispatch({type:'ERROR',payload:'Error occurred while fetching'})
        console.error('Error fetching programs:', res.data.message);
        setPrograms(null);

      }
    } catch (error) {
      dispatch({type:'ERROR',payload: error.message})

      console.error('Error while fetching data:', error);
      setPrograms(null);
    }
  };



  useEffect(() => {
   !programs && fetchPrograms();
  }, [rowsPerPage]);

  return (
    <div className="container">
      <Link to='/add-bug-bounty' className='btn btn-primary' >
        Add Bounty
      </Link>


      <div className="row">
        {programs ? (
          programs.map((program,index) => (
            <BugCard key={index} program={program} reload={fetchPrograms} />
          ))
        ) : (
          <>
            <div className='col-lg-3 p-2'>
              <Skeleton variant="rectangular" className="col-12" height={100} />
            </div>
            <div className='col-lg-3 p-2'>
              <Skeleton variant="rectangular" className="col-12" height={100} />
            </div>
            <div className='col-lg-3 p-2'>
              <Skeleton variant="rectangular" className="col-12" height={100} />
            </div>
            <div className='col-lg-3 p-2'>
              <Skeleton variant="rectangular" className="col-12" height={100} />
            </div>
            <div className='col-lg-3 p-2'>
              <Skeleton variant="rectangular" className="col-12" height={100} />
            </div>
            <div className='col-lg-3 p-2'>
              <Skeleton variant="rectangular" className="col-12" height={100} />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default BugList;